export default {
  overviewTitle: 'Project Prijzen',
  detailTitle: 'Project Prijs',
  deleteTitle: 'deze ProjectPrijs',
  url: '/manage/projectprice',
  apiUrl: '/projectprices/',
  sortBy: ['description'],
  sortDesc: [false],
  deletable: false,
  editable: true,
  filterName: 'manage/projectprice',
  quickFilter: {
    text: 'Zoek op description',
    value: 'description',
    type: 'text'
  },
  newRecord: {
  },
  // isReadOnlyOverview: true,
  // customEditable(item) {
  //   return false;
  // },
  // customDeletable(item) {
  //   return false;
  // },
  tableFields: [
    {text: 'Omschrijving', value: 'description', link: '/manage/projectprice/{id}', width: '10%'},
    {text: 'Tarief', value: 'rate', width: '10%'},
    {text: 'Tarief type', value: 'projectpricetype_name_nl', width: '10%'},
    {text: 'Diesel%', value: 'diesel_surcharge_percentage', width: '10%'}
  ]
};
